import { EntityState } from "@ngrx/entity";

import { CommentEntity } from '../entities';

export interface CommentState extends EntityState<CommentEntity> {
    isLoading: boolean,
    isLoaded: boolean,
    prevUrl: string,
    nextUrl: string
}